import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import { showMessage } from "store/misc/messageSlice";
import eventService from "services/eventService";
import customerService from "services/customerService";
import eventBookingService from "services/eventBookingService";

const initialState = {
	isSubmitting: false,
	eventInformation: null,
	customer: null,
	payment: null,
	package: null,
	eventSlots: [],
};

export const getEventSlots = createAsyncThunk(
	"eventBookingSlice/getEventSlots",
	async (eventId, { dispatch }) => {
		dispatch(showLoader());
		const eventSlots = await eventService.getEventSlots(eventId);
		dispatch(hideLoader());
		return eventSlots;
	}
);

export const getEvent = createAsyncThunk(
	"eventBookingSlice/getEvent",
	async (eventId, { dispatch }) => {
		dispatch(showLoader());
		const event = await eventService.get(eventId);
		dispatch(hideLoader());
		return event;
	}
);

export const bookEvent = createAsyncThunk(
	"eventBookingSlice/book/event",
	async ({ model, user, navigate }, { dispatch }) => {
		try {
			dispatch(setSubmitting(true));
			dispatch(showLoader());
			dispatch(setPayment(model.paymentMethod));
			let customerId;
			if (!user.isUserLoaded) {
				customerId = await customerService.create(model);
			}
			await eventBookingService.book(model, customerId);
			dispatch(
				showMessage({
					message: "Your wine tasting event successfully booked.",
					variant: "success",
				})
			);
			navigate("/eventBookingDetails");
		} catch (error) {
			console.error(error);
			dispatch(
				showMessage({
					message: "Error occurred while booking",
					variant: "error",
				})
			);
		} finally {
			dispatch(hideLoader());
			dispatch(setSubmitting(false));
		}
	}
);

const eventBookingSlice = createSlice({
	name: "vino/event/booking",
	initialState,
	reducers: {
		setSubmitting: (state, action) => {
			state.isSubmitting = action.payload;
		},
		setEventInformation: (state, action) => {
			state.eventInformation = action.payload;
		},
		setCustomer: (state, action) => {
			state.customer = action.payload;
		},
		setPayment: (state, action) => {
			state.payment = action.payload;
		},
		resetEventBooking: () => initialState,
	},
	extraReducers: {
		[getEventSlots.fulfilled]: (state, action) => {
			state.eventSlots = action.payload;
		},
		[getEvent.fulfilled]: (state, action) => {
			state.package = action.payload;
		},
	},
});

export const {
	setSubmitting,
	setEventInformation,
	setCustomer,
	setPayment,
	resetEventBooking,
} = eventBookingSlice.actions;

export default eventBookingSlice.reducer;
